'use strict';

/*
	boxes = collection of checkboxes
	links = collection of links, containing the corresponding checkbox in data-enable-checkbox on each item
*/
let boxes = document.querySelectorAll('[data-conditional-checkbox]'),
	triggers = document.querySelectorAll('[data-enable-checkbox]');

function enableCheckbox(event) {
	let checkbox = document.getElementById(event.currentTarget.dataset.enableCheckbox),
		trigger = event.currentTarget;

	checkbox.removeAttribute('readonly');
	trigger.removeEventListener('click', enableCheckbox);
}

if (boxes) {
	for (let i = 0; i < boxes.length; i++) {
		boxes[i].checked = false;
		boxes[i].setAttribute('readonly', true);
	}
}

if (triggers) {
	for (let i = 0; i < triggers.length; i++) {
		triggers[i].addEventListener('click', enableCheckbox);
	}
}
